import { MdOutlineIosShare } from "react-icons/md"
import { Route, useNavigate } from "react-router-dom"

import useShare from "@fuse/sharedComponents/globalShare/useShare"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { ROUTES } from "src/App"

import { DeepLinkPath, generateDeepLink } from "@fuse/utils/DeviceDection"

const AbstractcardOfTicket = ({
  eventDetail = {
    eventName: "",
    eventId: "",
  },
  userDetail = {
    name: "",
    userPhoneNumber: "",
    avatarUrl:
      "https://cubanvr.com/wp-content/uploads/2023/07/ai-image-generators.webp",
  },
  ticketDetail,
}: {
  eventDetail?: {
    eventName: string
    eventId: string
  }
  userDetail?: {
    name: string
    avatarUrl?: string
    userPhoneNumber: number | string
  }
  ticketDetail: {
    id: string
  }
}) => {
  const shareContent = useShare()
  const handleClickOnShare = (e) => {
    e.stopPropagation()
    onShareTicket()
  }
  const onShareTicket = () => {
    generateDeepLink({
      id: `${eventDetail?.eventId}/${userDetail.userPhoneNumber}`,
      path: DeepLinkPath.ClaimTicket,
    }).then((results: { shortLink: string }) => {
      shareContent({
        text: "Share this ticket",
        url: results?.shortLink,
        title: "Let's Hang!",
        type: DeepLinkPath.ClaimTicket,
      })
    })
  }
  const navigate = useNavigate()

  const onClickOfTicket = () => {
    let path = ROUTES.TICKETS.replace(":eventId", eventDetail?.eventId)
    path += `/${ROUTES.MY_TICKET_ID}`
    path = path.replace(":attendeeId", ticketDetail?.id)
    navigate(path)
  }
  return (
    <div onClick={onClickOfTicket}>
      {/* upper */}
      <div className="sm:w-[45vw]  max-w-md  min-w-max relative">
        <div className="absolute  top-1/2 -translate-y-1/2 px-6 lg:px-8  w-full">
          <FancyText className="text-white font-semibold text-lg md:text-2xl text-center">
            {eventDetail?.eventName}
          </FancyText>
        </div>
        <div>
          <svg
            width={"100%"}
            className="aspect-[300/60]"
            viewBox="0 0 300 60"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              {/* Ticket bottom section */}
              <path
                d="M0.01,10c0,-4.69 4.98,-9.99 10,-9.99h279.99c5.56,0 10.02,4.48 10.02,9.97v39.82h-0.01c-4.97,0.02 -9.99,5.1 -9.96,10.1h0.01v0.01H10.08v-0.02c-0.02,0 -0.04,5.02 -0.05,0 -0.01,-5.02 -5.03,-10.16 -10,-10.17v-39.77h0.01V10z"
                fill="#7F7F7F"
                fillOpacity="0.2"
              />
            </g>
          </svg>
        </div>
      </div>

      {/* middle */}
      <div className="sm:w-[45vw]  max-w-md  min-w-max relative">
        <div className="absolute flex justify-center gap-3 top-1/2 -translate-y-1/2 px-6 lg:px-8  w-full">
          <div className="w-6 md:w-8 aspect-square">
            <img
              src={userDetail?.avatarUrl}
              className="w-fill aspect-square rounded-full object-fill"
            />
          </div>
          <FancyText className="text-white text-base md:text-lg text-center">
            {userDetail?.name}
          </FancyText>
        </div>
        <div>
          <svg
            width={"100%"}
            className="aspect-[300/60]"
            viewBox="0 0 300 60"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              {/* Top dashed line */}
              <line
                stroke="white"
                strokeDasharray="3.47 3.47"
                strokeOpacity="0.2"
                strokeWidth="0.87"
                x1="13.01"
                x2="286.08"
                y1="0.45"
                y2="0.45"
              />

              {/* Main ticket shape */}
              <path
                d="M9.99,0.03v-0.05c0,5-4.96,10.01-9.98,10.03H0v40.01h0c5,0.02,9.97,5,9.97,9.98V60c0,0.02,0.05,0.04,0.03,0.04h280.03l-0.01,0h0.02c0-4,4.94-10.01,9.96-10.01h0.02V10h0c-4.98-0.01-10.01-4.97-10.02-9.98h0.02V0H9.99v0.03z"
                fill="#7F7F7F"
                fillOpacity="0.2"
              />

              {/* Bottom dashed line */}
              <line
                stroke="white"
                strokeDasharray="3.47 3.47"
                strokeOpacity="0.2"
                strokeWidth="0.87"
                x1="12.96"
                x2="284.54"
                y1="59.56"
                y2="59.56"
              />
            </g>
          </svg>
        </div>
      </div>

      {/* lower */}

      <div className="sm:w-[45vw]  max-w-md  min-w-max relative">
        <div
          className="absolute flex justify-center items-center gap-2  top-1/2 -translate-y-1/2 px-6 lg:px-8  w-full hover:cursor-pointer"
          onClick={handleClickOnShare}
        >
          <div>
            <MdOutlineIosShare color="white" size={20} />
          </div>
          <FancyText className="text-white text-base md:text-lg text-center">
            Share this ticket
          </FancyText>
        </div>

        <div>
          <svg
            width={"100%"}
            className="aspect-[300/60]"
            viewBox="0 0 300 60"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              {/* Main ticket shape */}
              <path
                d="M10,0v0.02c0.01,5-5,9.99-9.99,10.01H0v40.01c0,5,5.02,9.97,9.97,10h280c5.01,0,10.03-4.99,10-10.01V10h-0.01c-4.99,0.03-10.01-5-10.03-9.96h0.02V0H10z"
                fill="#7F7F7F"
                fillOpacity="0.2"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  )
}

export default AbstractcardOfTicket
